export default __webpack_public_path__ + "static/media/placeholder_portfolio03-en-mobile.3b807d0e.png";